import { render, staticRenderFns } from "./PageHorizontalComponent.vue?vue&type=template&id=ca6c642e&scoped=true"
import script from "./PageHorizontalComponent.vue?vue&type=script&lang=js"
export * from "./PageHorizontalComponent.vue?vue&type=script&lang=js"
import style0 from "./PageHorizontalComponent.vue?vue&type=style&index=0&id=ca6c642e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca6c642e",
  null
  
)

export default component.exports